import {
  REQUEST_ACCEPT,
  RECEIVE_ACCEPT,
  ACCEPT_FAILED
} from '../actions/types';

const acceptRequest = (state = {}, action) => {
  switch (action.type) {
    case REQUEST_ACCEPT:
      return Object.assign({}, state, {
        isFetching: true,
        accept: {},
        error: null
      });
    case RECEIVE_ACCEPT:
      return Object.assign({}, state, {
        isFetching: false,
        accept: action.accept,
        error: null
      });
    case ACCEPT_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        accept: action.accept,
        error: action.error
      });
    default:
      return state;
  }
};

export default acceptRequest;
